import React, { useState } from 'react';
import {
  Typography,
  Button,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
import {
  Download as DownloadIcon,
  Warning as WarningIcon
} from '@mui/icons-material';

const FilesDownloadPage = () => {
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [confirmDialog, setConfirmDialog] = useState({ open: false, filename: '', url: '' });

  // Пряме скачування через відкриття посилання (обходить CORS)
  const handleDownload = (filename, downloadUrl) => {
    // Створюємо невидиме посилання та клікаємо по ньому
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = filename; // намагаємося встановити назву файлу
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    setSuccess(`Файл "${filename}" почав завантаження`);
    setTimeout(() => setSuccess(''), 3000);
  };

  const handleDownloadClick = (filename, url) => {
    setConfirmDialog({ open: true, filename, url });
  };

  const handleConfirmDownload = () => {
    handleDownload(confirmDialog.filename, confirmDialog.url);
    setConfirmDialog({ open: false, filename: '', url: '' });
  };

  // Файли для скачування
  const filesToDownload = [
    {
      name: 'FastTuningTool.exe',
      url: 'https://pub-b9dde5b28ad541269be904340bfac306.r2.dev/FastTuningTool.exe'
    },
    {
      name: 'FastBackOfficeInstaller.exe',
      url: 'https://pub-cca2b6dcb1724a73adf1c5754464c028.r2.dev/FastBackOfficeInstaller.exe'
    }
  ];

  return (
    <Box sx={{ p: 3, maxWidth: 1400, margin: '0 auto', marginTop: '60px' }}>
      <Snackbar
        open={!!success}
        autoHideDuration={3000}
        onClose={() => setSuccess('')}
        message={success}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        ContentProps={{ sx: { backgroundColor: '#4caf50' } }}
      />
      
      <Snackbar
        open={!!error}
        autoHideDuration={5000}
        onClose={() => setError('')}
        message={error}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        ContentProps={{ sx: { backgroundColor: '#f44336' } }}
      />
      
      <Dialog
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ open: false, filename: '', url: '' })}
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <WarningIcon color="warning" />
            Підтвердження скачування
          </Box>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Ви впевнені, що хочете скачати файл "{confirmDialog.filename}"?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialog({ open: false, filename: '', url: '' })}>
            Скасувати
          </Button>
          <Button onClick={handleConfirmDownload} variant="contained" color="primary">
            Скачати
          </Button>
        </DialogActions>
      </Dialog>
      
      <Paper sx={{ p: 3, mb: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h5" component="h2">
            Завантаження інсталяторів
          </Typography>
        </Box>
        
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                <TableCell sx={{ fontWeight: 'bold' }}>Тип</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Назва</TableCell>
                <TableCell align="center" sx={{ fontWeight: 'bold' }}>Дія</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filesToDownload.map((file) => (
                <TableRow key={file.name} hover>
                  <TableCell>
                    <Box component="span" sx={{ color: '#d32f2f', fontSize: '24px' }}>📦</Box>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                      {file.name}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<DownloadIcon />}
                      onClick={() => handleDownloadClick(file.name, file.url)}
                      sx={{
                        textTransform: 'none',
                        minWidth: '100px'
                      }}
                    >
                      Скачати
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default FilesDownloadPage;